module.exports = __webpack_public_path__ + "media/camera-shutter-click-01.d5fb3f65.mp3";